import { EnumsInterface } from "@/interfaces/EnumsInterface";

const Behavior:EnumsInterface[] = [
    {id: 0, value: 0, label: "Suicidal Behavior"},
    {id: 1, value: 1, label: "Non-Suicidal Behavior"},
]

export default Behavior 